//desktop nav toggle
const shopButton = document.querySelector('.li_shop');
const desktopMenu = document.querySelector('.desktop-menu');

shopButton.addEventListener('mouseover', function () {
  desktopMenu.style.display = 'flex';
  $('body').removeClass('header_tras');
});

desktopMenu.addEventListener('mouseleave', function () {
  desktopMenu.style.display = 'none';
  $('body').addClass('header_tras');
});



// Body load opacity
$(document).ready(function () {
  $("body").animate({ opacity: 1 }, 700);
  /* Check the location of each desired element */
  $('.fade-up').each(function (i) {
    var bottom_of_object = $(this).offset().top + $(this).outerHeight();
    var bottom_of_window = $(window).scrollTop() + $(window).height() + 250;
    /* If the object is completely visible in the window, fade it in */
    if (bottom_of_window > bottom_of_object || $(window).scrollTop() > $(this).offset().top - 350) {
      $(this).animate({ 'opacity': '1' }, 400);
      /* 1500 is the duration of fade effect */
    }
  });

  setTimeout(function () {
    $(".fade-load").addClass('fade-active');
  }, 300);

});

// header height


$(window).on("load resize", (function () {
  var headerheight = $(".header-section").height();
 // $("#MainContent").css("margin-top", headerheight); 
}));


$(document).ready(function () {
 

  //promo banner slider 
  $('.announcement-bar-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    arrows: false,
    adaptiveHeight: false,
    autoplay: true,
    fade: true,
    dots: false
  });

  //text slider
  try {
    $('.text-slider').slick({
      dots: false,
      infinite: true,
      arrow: false,
      speed: 25000,
      centerMode: false,
      slidesToShow: 1,
      variableWidth: true,
      slidesToScroll: 1,
      cssEase: 'linear',
      autoplay: true,
      autoplaySpeed: 1,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            speed: 25000
          }
        }
      ]
    });
  } catch (err) { }


  // $(".mainPrice").appendTo(".product-form__buttons"); 




  $("#Search-In-Modal").keypress(function () {
    $(this).addClass('hidetext');
  });
  /*
    $('.instafeed_box').slick({
        dots: false,
        infinite: true,
        speed: 500,
        arrows: false,
        slidesToShow: 6,
        slidesToScroll: 1,
      responsive: [
    {
      breakpoint: 767,
      settings: {
            arrow:false,
              infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1
      }
    }
     ]
    });  */

  if ($(window).width() < 767) {
    setTimeout(function () {

      //    $('.rel-section_wrap').css('opacity', '1');
      /*$('.rel-slider').slick({
            dots: false,
            infinite: true,
            speed: 500,
            arrows: false,
            slidesToShow: 2,
            slidesToScroll: 1
         });  */
    }, 2000);
    /*
      $('.slidermobile-gutter ul').slick({
            dots: true,
            infinite: true,
            speed: 500,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1
         });  */




  }

  if ($(window).width() < 991) {
    setTimeout(function () {
      $("predictive-search").insertAfter("#mo_search i");
    }, 500);


    setTimeout(function () {
      $(".mo_open_pouch a").attr("href", "javascript:void(0)");
    }, 500);

    var navbox = $(".nav_row_1 .nav_box:last-child .nav_product-form").html()
    setTimeout(function () {
      $(".mo_open_pouch").append(navbox);
    }, 500);
  }





  //
  $(".footer__blocks-wrapper li.contact a").click(function () {
    localStorage.setItem('Name', 'contact');
  });

  $(".footer__blocks-wrapper li.faq a").click(function () {
    localStorage.setItem('Name', 'faq');
  });

  $(".footer__blocks-wrapper li.shipping-returns a").click(function () {
    localStorage.setItem('Name', 'shipping');
  });

  if (localStorage.getItem("Name") === null) {
    $(".footer-block li a").removeClass('list-menu__item--active');
  } else if (localStorage.getItem("Name") == 'contact') {
    //alert('1');
    setTimeout(function () {

      //alert('contact');
      $(".faq-section").css('opacity', '1');
      $(".left-links").find('button[data-id="contact"]').trigger('click');

    }, 500);

    setTimeout(function () {
      $(".left-links").find('button[data-id="contact"].tablinks').addClass('active');
      $(".footer-block ul li.contact a").addClass('list-menu__item--active');

      localStorage.clear();

    }, 600);
  } else if (localStorage.getItem("Name") == 'faq') {
    //alert('1');
    setTimeout(function () {

      //alert('faq');
      $(".faq-section").css('opacity', '1');
      $(".left-links").find('button[data-id="general"]').trigger('click');

    }, 500);

    setTimeout(function () {
      $(".left-links").find('button[data-id="general"].tablinks').addClass('active');
      $(".footer-block ul li.faq a").addClass('list-menu__item--active');

      localStorage.clear();

    }, 600);
  } else if (localStorage.getItem("Name") == 'shipping') {
    //alert('1');
    setTimeout(function () {

      //alert('shipping');
      $(".faq-section").css('opacity', '1');
      $(".left-links").find('button[data-id="shipping"]').trigger('click');

    }, 500);

    setTimeout(function () {
      $(".left-links").find('button[data-id="shipping"].tablinks').addClass('active');
      $(".footer-block ul li.shipping-returns a").addClass('list-menu__item--active');

      localStorage.clear();

    }, 600);
  } else {

  }


  //
  /*
  $(document).ready(function() {
    $(".footer-block li a").click(function(){
      if (window.location.href.indexOf("contact") > -1) {
        $(".left-links").find('button').removeClass('active');
        $(".footer-block li a").find('button').removeClass('active');
        
        $(".left-links").find('button[data-id="contact"]').addClass('active');
        $(".footer-block li.contact a").addClass('list-menu__item--active');
      }
  
      if (window.location.href.indexOf("shipping") > -1) {
        $(".left-links").find('button').removeClass('active');
        $(".footer-block li a").find('button').removeClass('active');
        
        $(".left-links").find('button[data-id="shipping"]').addClass('active');
        $(".footer-block li.shipping-returns a").addClass('list-menu__item--active');
      }
  
    if (window.location.href.indexOf("general") > -1) {
        $(".left-links").find('button').removeClass('active');
        $(".footer-block li a").find('button').removeClass('active');
        
        $(".left-links").find('button[data-id="general"]').addClass('active');
        $(".footer-block li.faq a").addClass('list-menu__item--active');
      }
    });  
    });  
    */


  //prevent search form from submission
  $(document).on("keydown", ".search-modal__form", function (event) {
    return event.key != "Enter";
  });

  $(".search__input").on("keypress", function () {
    $("label.field__label").hide();
  });

  $(".search-modal__close-button, .search-modal .modal-overlay").click(function () {
    $("label.field__label").show();
    $(".search__input").val('');
   // $(".header_tras").addClass('light');
  });

  $('.search__input').keyup(function () {
    var valThis = $(this).val().toLowerCase();
    if (valThis.length == 0) {
      $("label.field__label").show();
    }
  });
  document.querySelector('.search__button').disabled = true;

  $(".header__icon--search").click(function () {
 //  $(".header_tras").toggleClass('light');
  });


  $("#shopify-section-shop-menu2").appendTo(".header__inline-menu > ul > li.li_shop");
  $("#shopify-section-impact-menu").appendTo(".header__inline-menu > ul > li.li_impact");
  if ($("#shopify-section-impact-menu").children().length === 0) {
    $("#shopify-section-impact-menu").addClass('hidden')
  }

 var didScroll;
var lastScrollTop = 0;
var delta = 20;
var navbarHeight = $('header').outerHeight();

$(window).on('scroll', function () {
  didScroll = true;
});

setInterval(function () {
  if (didScroll) {
    hasScrolled();
    didScroll = false;
  }
}, 250);

function hasScrolled() {
  var st = $(window).scrollTop();

  // Ignore small scrolls
  if (Math.abs(lastScrollTop - st) <= delta) return;

  if (st > lastScrollTop && st > navbarHeight) {
    // Scroll Down
    $('.header-section').removeClass('nav-down nav-fix').addClass('nav-down');
  } else {
    // Scroll Up
    if (st <= 3) {
      // Near the top
      $('.header-section').removeClass('nav-down').addClass('nav-fix');
    } else {
      // Scrolling up but not at top
      $('.header-section').removeClass('nav-up nav-fix').addClass('nav-down');
    }
  }

  lastScrollTop = st;
}




  $("#RegisterForm-confirm-password").on('keyup', function () {
    var password = $("#RegisterForm-password").val();
    var confirmPassword = $("#RegisterForm-confirm-password").val();
    if (password != confirmPassword)
      $("#CheckPasswordMatch").html("Password does not match !").css("color", "red");
    else
      $("#CheckPasswordMatch").html("Password match !").css("color", "green");
  });


/*
  var stickybtn = $(".product-form__buttons button").html();

  $("#sticky_btclick").html(stickybtn);
*/

});


// $(function() {    
//     var timeoutId;
//     $(".header__inline-menu > ul > li.li_shop").hover(function() {



//         if (!timeoutId) {
//             timeoutId = window.setTimeout(function() {
//                 timeoutId = null;
//                 $("#shopify-section-shop-menu2").fadeIn('fast');

//                  document.querySelector('.desktop-menu').style.display = 'flex';
//            }, 400);
//         }
//     },
//     function () {
//         if (timeoutId) {
//             window.clearTimeout(timeoutId);
//             timeoutId = null;
//         }
//         else {
//            $("#shopify-section-shop-menu2").fadeOut('fast');
//            document.querySelector('.desktop-menu').style.display = 'none';
//         }
//     });

//impact
var timeoutId2;
$(".header__inline-menu > ul > li.li_impact").hover(function () {
  if (!timeoutId2) {
    timeoutId2 = window.setTimeout(function () {
      timeoutId2 = null;
      $("#shopify-section-impact-menu").fadeIn('fast');
    }, 400);
  }
},
  function () {
    if (timeoutId2) {
      window.clearTimeout(timeoutId2);
      timeoutId2 = null;
    }
    else {
      $("#shopify-section-impact-menu").fadeOut('fast');
    }
  });

/*
  var timeoutIds;
    $(".nav-list__item--about").hover(function() {
        if (!timeoutIds) {
            timeoutIds = window.setTimeout(function() {
                timeoutIds = null;
                $(".submenus").fadeIn('fast');
           }, 700);
        }
    },
    function () {
        if (timeoutIds) {
            window.clearTimeout(timeoutIds);
            timeoutIds = null;
        }
        else {
           $(".submenus").fadeOut('fast');
        }
    });
  */


// FADE EFFECT
/* Every time the window is scrolled ... */
$(window).scroll(function () {
  /* Check the location of each desired element */
  $('.fade-up').each(function (i) {
    var bottom_of_object = $(this).offset().top + $(this).outerHeight();

    if ($(window).width() < 767) {
      var bottom_of_window = $(window).scrollTop() + $(window).height() + 400;
    } else {
      var bottom_of_window = $(window).scrollTop() + $(window).height() + 550;
    }
    /* If the object is completely visible in the window, fade it in */
    if (bottom_of_window > bottom_of_object || ($(window).width() < 767 && $(window).scrollTop() > $(this).offset().top - 650)) {
      $(this).animate({ 'opacity': '1' }, 500);
      /* 1500 is the duration of fade effect */
    }
  });
});

/*
$(document).on("click", "#sticky_btclick", function () {
  $(".product-form__buttons button").trigger('click');
});*/

$(document).on("click", ".product-form__input input[type='radio'] + label", function () {
  setTimeout(function () {
    var stickybtn = $(".product-form__buttons button").html();
    $("#sticky_btclick").html(stickybtn);
  }, 1000);
});

$(document).on("click", ".sublink_1", function () {
  $(".nav_row_1").addClass('active');
  $(".nav_row_2").removeClass('active');
  $(".nav_row_3").removeClass('active');
  $(this).addClass('active');
  $(".sublink_2").removeClass('active');
  $(".sublink_3").removeClass('active');
});
$(document).on("click", ".sublink_2", function () {
  $(".nav_row_2").addClass('active');
  $(".nav_row_1").removeClass('active');
  $(".nav_row_3").removeClass('active');
  $(this).addClass('active');
  $(".sublink_1").removeClass('active');
  $(".sublink_3").removeClass('active');
});
$(document).on("click", ".sublink_3", function () {
  $(".nav_row_3").addClass('active');
  $(".nav_row_1").removeClass('active');
  $(".nav_row_2").removeClass('active');
  $(this).addClass('active');
  $(".sublink_1").removeClass('active');
  $(".sublink_2").removeClass('active');
});



//cookie code
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires;
}
function _fnaccept() {
  setCookie('isvisited', 'yes', 30);
  setCookie('isvisitedpopup', 'yes', 30);
  if($('#shopify-section-site_newsletter').length) {
    $("#shopify-section-site_newsletter").fadeOut();
  }
  if($('#shopify-section-cookies').length) {
    $("#shopify-section-cookies").fadeOut();
  }
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1);
    if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
  }
  return "";
}

$(function () {

  //Smooth scrolling with links


  $('#privacy-policy_body #MainContent ol li a[href^=\\#]').on('click', function (event) {
    event.preventDefault();
    $('html,body').animate({ scrollTop: $(this.hash).offset().top }, 500);
  });
  $('#term-condition_body #MainContent ol li a[href^=\\#]').on('click', function (event) {
    event.preventDefault();
    $('html,body').animate({ scrollTop: $(this.hash).offset().top }, 500);
  });

  var storage = window.localStorage; //set localstorage object in storage var
  if (localStorage.getItem("loading_bar_flag") === null) {
  } else {
    //alert('cookie set previously');
    $(".header").addClass('border_active');
    $(".banner-cap").addClass('active');
    $(".header__heading").addClass('active_logo');

  }

  var isvisited = getCookie("isvisited");
  var isvisitedpopup = getCookie("isvisitedpopup");

  if (isvisited == null || isvisited == '') {
    $(window).on('load', function () {
      $("#shopify-section-cookies").fadeIn();
    });
  }

  $(".cookie_accept").click(function () {
    setCookie('isvisited', 'yes', 30);
    $("#shopify-section-cookies").fadeOut();
  });

  //if blank then show on load
  if (isvisitedpopup == null || isvisitedpopup == '') {
    $(window).on('load', function () {
      if($('#shopify-section-site_newsletter').length) {
        $("#shopify-section-site_newsletter").fadeIn();
      } else {
        storage.setItem("loading_bar_flag", 1);
        $(".header").addClass('border_active');
        $(".banner-cap").addClass('active');
        $(".header__heading").addClass('active_logo');
      }
    });
  } else {
    //alert('3');
    $(".header").addClass('border_active');
    $(".banner-cap").addClass('active');
    $(".header__heading").addClass('active_logo');
  }

  function closePopup() {
    setCookie('isvisitedpopup', 'yes', 30);
    if($('#shopify-section-site_newsletter').length) {
      $("#shopify-section-site_newsletter").fadeOut();
    }

    // Loadbar Animation only once using localstorage

    if (storage.getItem("loading_bar_flag") == 1) {
      // alert('1');
      $(".header").addClass('border_active');
      $(".banner-cap").addClass('active');
      $(".header__heading").addClass('active_logo');

    } else {
      // alert('popupclosed');
      //loading animation only once  
      setTimeout(function () {
        $(".load_bg").addClass('active');
        $(".load_logo").addClass('active');
      }, 300);

      setTimeout(function () {
        $(".header__heading").addClass('active_logo');
      }, 2100);

      if ($(window).width() < 767) {
        setTimeout(function () {
          $(".header").addClass('border_active');
          $(".banner-cap").addClass('active');
        }, 700);

      } else {


        setTimeout(function () {
          $(".header").addClass('border_active');
          $(".banner-cap").addClass('active');
        }, 2100);
      }
      //store in localstorage 
      storage.setItem("loading_bar_flag", 1);

    }
    //end here
  }

  //newsletter close
  $(".close_popup").click(closePopup);

  $(".popup_overlay").click(closePopup);



});
//end cookie and newsletter



//newsletter popup - on successful submission hide popup
window.addEventListener("klaviyoForms", function (e) {
  if (e.detail.type == 'submit') {
    var storage = window.localStorage;
    //alert('form submitted');
    setCookie('isvisitedpopup', 'yes', 30);
    //store in localstorage 
    storage.setItem("loading_bar_flag", 1);
    //  alert('stored');
    setTimeout(function () {
      if($('#shopify-section-site_newsletter').length) {
        $("#shopify-section-site_newsletter").fadeOut();
      }
       $(".popup_column .heading_h3, p.info").addClass('hide');

      //loading animation only once  
      // setTimeout(function () {
      //   $(".load_bg").addClass('active');
      //   $(".load_logo").addClass('active');
      // }, 300);
      //
      // setTimeout(function () {
      //   $(".header__heading").addClass('active_logo');
      // }, 2100);
      //
      // setTimeout(function () {
      //   $(".header").addClass('border_active');
      //   $(".banner-cap").addClass('active');
      // }, 2100);



    }, 200);


  }
  //end here
});

/*
$(window).scroll(function() {
    var winHeight = $(this).height();
    var scrollTop = $(this).scrollTop();    
    $("#product_tab").each(function(index){ 
        var elemHeight = $(this).height();
        var elementTop = $(this).position().top + 750; 
        if (elementTop < scrollTop + winHeight && scrollTop < elementTop + elemHeight )
           $(".sticky-addtocart").eq(index).addClass("active");
        else
           $(".sticky-addtocart").eq(index).removeClass("active");
    });
});*/




$('body').on('click', '.motabitem', function (e) {
  $('.motabitem').not(this).removeClass('activetab');
  $(this).toggleClass('activetab');

  $('.tab-mobox').find('.tab-text').stop().slideUp();
  $(this).closest('.tab-mobox').find('.tab-text').stop().slideToggle();
});

$('body').on('click', '#momenu_icon', function (e) {
  $("#mo-navigation").toggleClass('active');
});
$('body').on('click', '.child-menu', function (e) {
  $('li').find('.mosubmenu').stop().slideUp();
  $(this).closest('li').find('.mosubmenu').stop().slideToggle();

  $('.child-menu').not(this).removeClass('active');
  $(this).toggleClass('active');
});

$('li.newsletter a').attr('href', 'javascript:void(0)');
$('a.p_sign-up').attr('href', 'javascript:void(0)');
$('body').on('click', 'li.newsletter a, a.p_sign-up', function (e) {
  if($('#shopify-section-site_newsletter').length) {
    $("#shopify-section-site_newsletter").fadeIn();
  }
});
$('body').on('click', '.popup_overlay', function (e) {
  if($('#shopify-section-site_newsletter').length) {
    $("#shopify-section-site_newsletter").fadeOut();
  }
});
/*
$('body').on('click', 'li.accessibility a', function(e) { 
    $("#accessiblyOtm .accessibly-otm-widget").removeClass('accessibly-otm-hidden');
});*/
// $("li.accessibility a").attr('href', 'javascript:void(0)' );

function initFooterMenu() {
  $('body').off('click', '.footer-block__heading');

  if ($(window).width() < 992) {
    $('body').on('click', '.footer-block__heading', function (e) {
      $('.footer-block__heading').not(this).removeClass('active');
      $(this).toggleClass('active');

      $('.footer-block--menu').find('.footer-block__details-content').stop().slideUp();
      $(this).closest('.footer-block--menu').find('.footer-block__details-content').stop().slideToggle();
    });
  } else {
    // On larger screens, ensure all content is visible and remove active states
    $('.footer-block__heading').removeClass('active');
    $('.footer-block--menu').find('.footer-block__details-content').show();
  }
}

// Initialize on page load
$(document).ready(function() {
  initFooterMenu();
});

let resizeTimer;
$(window).on('resize', function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
    initFooterMenu();
  }, 250);
});


$(document).on('click', '.mo_open_pouch a', function (e) {
  $(".nav_row_1 .nav_box:last-child .BIS_trigger").trigger("click");
  $(".nav_row_1 .nav_box:last-child .BIS_trigger").css('border', '10px solid red');

});
